
import { Textarea } from "@/components/ui/textarea";

interface RichTextEditorProps {
  content: string;
  onChange: (content: string) => void;
}

export const RichTextEditor = ({ content, onChange }: RichTextEditorProps) => {
  return (
    <div className="border rounded-lg">
      <Textarea
        value={content}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Write your blog content here..."
        className="min-h-[400px] border-0 focus-visible:ring-0 resize-none"
      />
    </div>
  );
};
